import { useState, useEffect } from "react";
import quizData from "../../data/home.json";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import articleData from "../../data/financeFacts.json";
import FactsSection from "../../components/FactsSection";
import AdComponent from "../../components/AdComponent";
const Search = () => {
    const [categories, setCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const article = articleData?.PAGE7 || {};
    useEffect(() => {
        const now = new Date();
        const currentTime = now.toTimeString().slice(0, 8);
        const filtered = quizData.filter(
            (c) => {
                return c.status === "live";
            }
        );
        setCategories(filtered);
        setFilteredCategories(filtered); // Initialize filtered categories with all categories
    }, []);

    console.log("Categories:", categories);
    console.log("Filtered Categories:", filteredCategories);
    console.log("Search Query:", searchQuery);

    useEffect(() => {
        if (searchQuery.trim() === "") {
            setFilteredCategories(categories);
        } else {
            const filtered = categories.filter((category) =>
                category.topic_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                category.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                category.description?.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredCategories(filtered);
        }
    }, [searchQuery, categories]);

    // Get unique categories for slider
    const getUniqueCategories = () => {
        const shown = new Set();
        const unique = [];
        
        filteredCategories.forEach((category) => {
            if (!shown.has(category.topic_name)) {
                shown.add(category.topic_name);
                unique.push(category);
            }
        });
        
        return unique;
    };
  
    const uniqueCategories = getUniqueCategories();

    // Handle search input change
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
    };

    // Clear search
    const clearSearch = () => {
        setSearchQuery('');
    };

    return (
        <>
            <div className="search-bar-wrap d-flex align-items-center gap-2">
                <Link to={"/"} className="search-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M11.5293 6.47001C11.6698 6.61064 11.7487 6.80126 11.7487 7.00001C11.7487 7.19876 11.6698 7.38939 11.5293 7.53001L7.80934 11.25H17.9993C18.1983 11.25 18.389 11.329 18.5297 11.4697C18.6703 11.6103 18.7493 11.8011 18.7493 12C18.7493 12.1989 18.6703 12.3897 18.5297 12.5303C18.389 12.671 18.1983 12.75 17.9993 12.75H7.80934L11.5293 16.47C11.603 16.5387 11.6621 16.6215 11.7031 16.7135C11.7441 16.8055 11.7662 16.9048 11.7679 17.0055C11.7697 17.1062 11.7512 17.2062 11.7135 17.2996C11.6757 17.393 11.6196 17.4778 11.5484 17.549C11.4772 17.6203 11.3923 17.6764 11.2989 17.7141C11.2055 17.7519 11.1055 17.7704 11.0048 17.7686C10.9041 17.7668 10.8048 17.7448 10.7128 17.7038C10.6208 17.6628 10.538 17.6037 10.4693 17.53L5.46934 12.53C5.32889 12.3894 5.25 12.1988 5.25 12C5.25 11.8013 5.32889 11.6106 5.46934 11.47L10.4693 6.47001C10.61 6.32956 10.8006 6.25067 10.9993 6.25067C11.1981 6.25067 11.3887 6.32956 11.5293 6.47001Z" fill="white"/>
                    </svg>
                </Link>
                <div className="sidebar-search">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" role="img" className="icon">
                        <path d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        </path>
                    </svg>
                    <input 
                        type="text" 
                        id="searchInput" 
                        placeholder="Search quizzes..." 
                        value={searchQuery}
                        onChange={handleSearchChange}
                    /> 
                    {searchQuery && (
                        <button 
                            type="button" 
                            onClick={clearSearch}
                            className="clear-search-btn"
                            style={{ 
                                background: 'none', 
                                border: 'none', 
                                color: 'white', 
                                cursor: 'pointer',
                                fontSize: '18px',
                                padding: '2px 8px'
                            }}
                        >
                            ×
                        </button>
                    )}
                </div>
            </div>

            <div id="quizSearch">
                {filteredCategories.length > 0 && (
                    <section className="quiz-slider-section pb">
                        <div className="container">
                            <Swiper
                                slidesPerView="auto"
                                spaceBetween={10}
                                loop={false}
                                freeMode={true}
                                breakpoints={{
                                    420: {
                                        slidesPerView: "auto",
                                        spaceBetween: 10,
                                    },
                                }}
                                className="quizTopicSwiper"
                            >
                                <SwiperSlide>
                                    <Link className="quiz-card" to={"/"} tabIndex="0">
                                        <div className="quiz-icon">
                                            <img src="/assets/images/card-6.png" alt="Finance" />
                                        </div>
                                        <p>All Contests</p>
                                    </Link>
                                </SwiperSlide>

                                {uniqueCategories &&
                                    uniqueCategories.map((category) => (
                                        <SwiperSlide key={category.id}>
                                            <div className="quiz-card" tabIndex="0">
                                                <div className="quiz-icon">
                                                    <img src={category.category_image} alt={category.topic_name} />
                                                </div>
                                                <p>{category.topic_name}</p>
                                            </div>
                                        </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </section>
                )} 
                
                <section className="quiz-list-section">
                    <div className="container">
                        <h2>Quiz List</h2>
                        <p className="subtitle">
                            {filteredCategories.length} quiz{filteredCategories.length !== 1 ? 'es' : ''} 
                            {searchQuery ? ` found for "${searchQuery}"` : ' - explore your favorite'}
                        </p>
                        
                        {filteredCategories.length > 0 ? (
                            <div className="quiz-list">
                                {filteredCategories.map((category) => (
                                    <Link 
                                        className="quiz-item" 
                                        to={`/join-contest/${category.id}`} 
                                        key={category.id}
                                    >
                                        <div className="quiz-icon">
                                            <img src={category.category_image} alt={category.name || category.topic_name} />
                                        </div>
                                        <div className="quiz-info">
                                            <h3>
                                                Play and Win {Number(category.winner_coins).toLocaleString()} Coins
                                            </h3>
                                            <p>
                                                {category.topic_name.toUpperCase()}, 
                                                Entry: {category.entry_fee > 0 ? `${category.entry_fee} Coins` : 'Free'}
                                            </p>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        ) : searchQuery ? (
                            <div className="no-results text-center py-4">
                                <p>No quizzes found for "{searchQuery}"</p>
                                <button 
                                    onClick={clearSearch}
                                    className="play-btn btn mt-2"
                                >
                                    Clear
                                </button>
                            </div>
                        ) : null}
                    </div>
                </section>
                <AdComponent />
                <section className="pt-5 facts-section">
                    <div className="container">
                        <div className="finance-fact">
                            <h2 className="fw-bold mb-4">{article?.title}</h2>
                        </div>
                        {
                            article?.content?.map((item, index) => (
                                <FactsSection key={index} item={item} />
                            ))
                        }
                        <div className="article-card">
                            <h2 className="article-card-title">{article?.action?.title}</h2>
                            
                            <p className="article-card-desc">
                                <strong className="desc-color">{article?.action?.title1}</strong> {article?.action?.desc1}
                            </p>
                            
                            <p className="article-card-desc">
                                <strong  className="desc-color">{article?.action?.title2}</strong> {article?.action?.desc2}
                            </p>
                            
                            <p className="article-card-desc">
                                {
                                    article?.action?.list.map((list, index) => (
                                        <>{list}<br /></>
                                    ))
                                }
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}

export default Search;